require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-history-is-taking-shape-at-fourdrinier-house-in-yarrabend.json") })
        }
      }, "path---news-history-is-taking-shape-at-fourdrinier-house-in-yarrabend");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-history-is-taking-shape-at-fourdrinier-house-in-yarrabend!./.cache/json/news-history-is-taking-shape-at-fourdrinier-house-in-yarrabend.json
// module id = 820
// module chunks = 231608221292675